import { render } from "./app.vue?vue&type=template&id=6ae60c32"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=6ae60c32&lang=css"
script.render = render

export default script